<template>
<!-- THREAD PAGES -->
<div class="threadlist__forumPagesFlex">
  <div class="threadlist__pages" v-if="totalPages > 1">
    <div class="threadlist__pageblock first"><a title="Перейти на страницу:...">{{ totalPages }} Страницы</a></div>
    <div class="threadlist__pageblock firstLast" v-if="currPage >= 4"><a :href="'index.php?showforum='+forumId" title="На первую страницу">«</a></div>
    <div class="threadlist__pageblock" v-if="currPage >= 2"><a :href="'index.php?showforum='+forumId+'&st='+getStFromPage(currPage-1)" title="Предыдущая страница">&lt;</a></div>
    <div class="threadlist__pageblock" v-if="currPage >= 3"><a :href="'index.php?showforum='+forumId+'&st='+getStFromPage(currPage-2)" :title="currPage-2">{{currPage-2}}</a></div>
    <div class="threadlist__pageblock" v-if="currPage >= 2"><a :href="'index.php?showforum='+forumId+'&st='+getStFromPage(currPage-1)" :title="currPage-1">{{currPage-1}}</a></div>
    <!-- current page -->
    <template v-if="preciselyOnPage">
      <div class="threadlist__pageblock currentPage">{{currPage}}</div>
    </template>
    <template v-else>
      <div class="threadlist__pageblock currentPage"><a :href="'index.php?showforum='+forumId+'&st='+getStFromPage(currPage)" :title="currPage">{{currPage}}</a></div>
    </template>
    <!-- end of "current page" -->
    <div class="threadlist__pageblock" v-if="currPage < totalPages"><a :href="'index.php?showforum='+forumId+'&st='+getStFromPage(currPage+1)" :title="currPage+1">{{currPage+1}}</a></div>
    <div class="threadlist__pageblock" v-if="currPage + 1 < totalPages"><a :href="'index.php?showforum='+forumId+'&st='+getStFromPage(currPage+2)" :title="currPage+2">{{currPage+2}}</a></div>
    <div class="threadlist__pageblock" v-if="currPage < totalPages"><a :href="'index.php?showforum='+forumId+'&st='+getStFromPage(currPage+1)" title="Следующая страницу">&gt;</a></div>
    <div class="threadlist__pageblock firstLast" v-if="currPage + 3 <= totalPages"><a :href="'index.php?showforum='+forumId+'&st='+getStFromPage(totalPages)" title="На последнюю страницу">»</a></div>
  </div>
  <div class="threadlist__newposticons">
    <a><img src="../assets/t_new.gif" /></a>
    <a><img src="../assets/t_poll.gif" /></a>
  </div>

</div>
<!-- END OF PAGES -->
</template>

<script>
export default {
  props: ['normThreads', 'pinnedThreads', 'forumId'],
  methods: {
    getStFromPage(page) {
      return (page - 1) * 30;
    }
  },
  computed: {
    totalPages() {
      return Math.ceil((this.normThreads + this.pinnedThreads) / 30);
    },
    currPage() {
      return this.$route.query.st ? Math.floor(Number(this.$route.query.st) / 30) + 1 : 1;
    },
    preciselyOnPage() {
      return this.$route.query.st ? Number(this.$route.query.st) % 30 === 0 : true;
    }
  }
}
</script>

<style lang="scss">
@import "./ThreadsList.scss";
</style>
